import React, { Fragment } from "react";
import { Button, Tooltip } from "@duxton-web/ui";
import { LaunchGrabappOutlined } from "@duxton-web/icons";
import { TroyDownloadAppModal } from "troy-portal/download-app-modal";
import I18n from "i18n-js";
import { MODAL_TYPE_DOWNLOAD_APP } from "../../constants";

const SidebarDownloadAppV2 = (props) => {
  const {
    handleOpenModal,
    handleCloseModal,
    collapsed,
    isModalOpen,
    modalType,
  } = props;
  const isModalVisible = isModalOpen && modalType === MODAL_TYPE_DOWNLOAD_APP;

  const handleDownloadAppBtnClick = (e) => {
    handleOpenModal(MODAL_TYPE_DOWNLOAD_APP);
    e.target.blur();
  };

  const onClick = (e) => {
    if (collapsed) handleOpenModal(MODAL_TYPE_DOWNLOAD_APP);
    else handleDownloadAppBtnClick(e);
  };

  const getDownloadButton = () => {
    return (
      <Button
        data-testid="downloadAppButton"
        shape={collapsed ? "circle" : undefined}
        icon={
          <LaunchGrabappOutlined
            style={collapsed ? { fontSize: 20 } : undefined}
          />
        }
        onClick={onClick}
      >
        {collapsed ? "" : I18n.t("troyCommon-navigation-002-002")}
      </Button>
    );
  };

  return (
    <Fragment>
      {collapsed ? (
        <Tooltip
          title={I18n.t("troyCommon-navigation-002-002")}
          placement="right"
        >
          {getDownloadButton()}
        </Tooltip>
      ) : (
        getDownloadButton()
      )}
      <TroyDownloadAppModal
        visible={isModalVisible}
        onCancel={() => handleCloseModal(MODAL_TYPE_DOWNLOAD_APP)}
      />
    </Fragment>
  );
};

export default SidebarDownloadAppV2;
